import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { proofImages } from '../data/proofImages';
type Review = {
  name: string;
  role: string;
  content: string;
  avatar: string | null;
  avatarPosition?: string;
};
const reviews: Review[] = [{
  name: 'Liliana Leal',
  role: 'Cliente Verificada',
  content: 'Altamente recomendado, servicio excepcional y con muy buena atención. Gracias a Eduardo y a su equipo mi crédito está excelente y ya estoy buscando capital para mi negocio.',
  avatar: 'https://cdn.magicpatterns.com/uploads/hJXdKb1Zim1tL1u7PKF42S/IMG_0415.jpg',
  avatarPosition: 'object-[20%_35%]'
}, {
  name: 'Liliana Rodriguez',
  role: 'Cliente Verificada',
  content: 'Gracias a la asesoría de Edu, logré obtener hasta 40.000 dólares en mi primera tarjeta de crédito de negocios con Chase. Increíble resultado. ¿Mi consejo? Déjense guiar del mejor.',
  avatar: 'https://cdn.magicpatterns.com/uploads/6Eiyt6b2wk5nugeq5wJ1Eh/IMG_0818.jpg'
}, {
  name: 'Edgar Morales',
  role: 'Cliente Verificado',
  content: 'Tenía 7 collections en mi reporte de crédito y Eduardo y su equipo las removieron todas en menos de 60 días. Un resultado increíble, me sorprendió. Se los recomiendo a todos.',
  avatar: 'https://cdn.magicpatterns.com/uploads/4rr4pee8LoLBE4Rgz6MsKS/IMG_0819.jpg'
}, {
  name: 'Leonardo Cuello',
  role: 'Propietario de Casa',
  content: 'No podía comprar mi casa hasta que Eduardo y el equipo de Vantix me ayudaron. Literalmente no podía cerrar el negocio porque mi puntaje no estaba bien; luego lo arreglamos y ahora voy por mi segunda casa.',
  avatar: 'https://cdn.magicpatterns.com/uploads/gwsbtdrRTYn5J3CCGfeR2z/IMG_0820.jpg'
}, {
  name: 'Juan Soto',
  role: 'Cliente Verificado',
  content: 'Atención excelente, recomendados al 100%.',
  avatar: 'https://cdn.magicpatterns.com/uploads/tjQxQtsc2cSbqyDTqq7foW/IMG_0821.jpg'
}];
function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <article className="flex flex-col w-[300px] sm:w-[360px] shrink-0 p-7 rounded-xl bg-ink-850 border border-white/10" data-id="element-169" data-mp="1r4h9afescfku">
      <div className="flex gap-1 mb-5" data-id="element-170" data-mp="1cg49f7ckucl2">
        {[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-171" data-mp="1hee8vu5c3zch" data-mpi={i} />)}
      </div>

      <p className="text-white/85 font-normal leading-relaxed text-[15px] mb-7 flex-grow" data-id="element-172" data-mp="13ewg73ox41xu">
        {review.content}
      </p>

      <div className="h-px w-full bg-white/10 mb-5" data-id="element-173" data-mp="18e9c0dxrojck" />

      <div className="flex items-center gap-3" data-id="element-174" data-mp="18bwo7k5bverl">
        <div className="h-10 w-10 rounded-full bg-ink-800 border border-white/10 flex items-center justify-center text-white/70 font-semibold text-xs shrink-0 overflow-hidden" data-id="element-175" data-mp="thi7jq98khg3">
          {review.avatar ? <img src={review.avatar} alt={review.name} className={`h-full w-full object-cover ${review.avatarPosition ?? ''}`} data-id="element-176" data-mp="2nvswrztqtdme" /> : review.name.split(' ').map(n => n[0]).slice(0, 2).join('')}
        </div>
        <div data-id="element-177" data-mp="qwakcqtgcy6q">
          <div className="text-white font-semibold text-[15px] leading-tight" data-id="element-178" data-mp="qwso08ig2eoo">
            {review.name}
          </div>
          <div className="text-[13px] text-white/60" data-id="element-179" data-mp="m4j2d4od40s7">{review.role}</div>
        </div>
      </div>
    </article>;
}
export function Reviews() {
  // Duplicated once so the track can loop seamlessly at -50%
  const loop = [...reviews, ...reviews];
  const imageLoop = [...proofImages, ...proofImages];
  return <section id="resultados" className="py-20 md:py-28 bg-black border-t border-white/10 overflow-hidden" data-id="element-180" data-mp="19ttxa5j170yf">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-12 md:mb-16" data-id="element-181" data-mp="14tz4txjly3b9">
        <p className="text-[11px] font-semibold tracking-[0.3em] uppercase text-gold mb-5" data-id="element-182" data-mp="3i2ryvdc2iz0x">
          Resultados comprobados
        </p>
        <h2 className="text-3xl md:text-[2.75rem] font-semibold text-white tracking-tight mb-4 leading-[1.18]" data-id="element-183" data-mp="3n0th5w1o6ubc">
          Ellos confiaron, <span className="text-gold" data-id="element-184" data-mp="2pfxgclyta9q3">dijeron que sí</span> y
          acá están sus resultados
        </h2>
        <p className="text-base md:text-lg text-white/80 font-normal max-w-lg mx-auto leading-relaxed" data-id="element-185" data-mp="2ub329ks7roe6">
          Casos reales de clientes que decidieron poner su crédito en orden.
        </p>
      </motion.div>

      {/* Testimonial marquee */}
      <div className="marquee-viewport relative overflow-hidden" data-id="element-186" data-mp="26oeg2mw699rr">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-40 z-10 bg-gradient-to-r from-black to-transparent" data-id="element-187" data-mp="26ls66glt6i6d" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-40 z-10 bg-gradient-to-l from-black to-transparent" data-id="element-188" data-mp="sruyksgnxvob" />

        <div className="marquee-track flex gap-5 w-max px-3" data-id="element-189" data-mp="oqrji86fw3o5">
          {loop.map((review, index) => <ReviewCard key={index} review={review} data-id="element-190" data-mp="jp28utn4ps0l" data-mpi={index} />)}
        </div>
      </div>

      {/* Proof images, scrolling the opposite way */}
      <div className="marquee-viewport relative overflow-hidden mt-5" data-id="element-191" data-mp="9t8yngwvualz">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-40 z-10 bg-gradient-to-r from-black to-transparent" data-id="element-192" data-mp="9uk37iy5jme5" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-40 z-10 bg-gradient-to-l from-black to-transparent" data-id="element-193" data-mp="zm57xg5djfy" />

        <div className="marquee-track-reverse flex gap-5 w-max px-3" data-id="element-194" data-mp="3s89nu5n06sjt">
          {imageLoop.map((image, index) => <div key={index} className="h-[380px] sm:h-[480px] shrink-0 rounded-xl overflow-hidden bg-ink-850 border border-white/10" data-id="element-195" data-mp="3n9q66hfg02x9" data-mpi={index}>
              <img src={image.src} alt={image.alt} loading="lazy" className="h-full w-auto block object-cover" data-id="element-196" data-mp="38jbyvhf37vg2" />
            </div>)}
        </div>
      </div>
    </section>;
}